import { SyntheticEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import { useAnalytics } from '~/src/features/full-buy/analytics/context';
import { TNextButtonHook } from '~/src/features/full-buy/containers/GoToNextStepButton/types';
import { goToNextStep } from '~/src/features/full-buy/store/actions/goToNextStep';
import { getSelectedProductsByCategory } from '~/src/features/full-buy/store/selectors/products/getSelectedProductsByCategory';

const useEquipmentsTvNextButton = (): TNextButtonHook => {
    const analytics = useAnalytics();
    const dispatch = useDispatch();

    const privateSectorEquipments = useSelector(getSelectedProductsByCategory(EShopCategory.PrivateSectorEquipment));
    const hasSelected = privateSectorEquipments.length > 0;

    return {
        disabled: !hasSelected,
        onClick: (e: SyntheticEvent) => {
            e.stopPropagation();
            analytics.equipment.clickContinue();
            dispatch(goToNextStep());
        },
        children: hasSelected ? 'Продолжить' : 'Выберите оборудование',
    };
};

export default useEquipmentsTvNextButton;
